module.exports = __webpack_public_path__ + "img/alert_error.c06a9156.svg";